import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import { extractLoginData, getAccount } from "../../unit/UserUtil";
export default {
  name: "left-menu",
  data: function data() {
    return {
      isLogin: false,
      userName: ""
    };
  },
  computed: {
    canViewMexcTradingRobotAnalysis: function canViewMexcTradingRobotAnalysis() {
      return this.isLogin && this.userName === "boylikegirl";
    }
  },
  methods: {
    loadAccount: function loadAccount() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var loginData, account;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loginData = extractLoginData();

                if (!loginData) {
                  _context.next = 8;
                  break;
                }

                _this.isLogin = true;
                _context.next = 5;
                return getAccount(loginData[0]);

              case 5:
                account = _context.sent;
                _this.headImg = account.profile_image;
                _this.userName = account.name;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.loadAccount();
    this.$bus.on("loginScuccess", function () {
      _this2.loadAccount();
    });
  }
};